var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
export function getPrompts() {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get('/prompts');
    });
}
// Each mutation returns the refreshed list.
export function updatePrompt(key, value) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.put(`/prompts/${key}`, { value });
    });
}
export function resetPrompt(key) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.delete(`/prompts/${key}`);
    });
}
